export const enums = {
        judgeIp:"https://aggshop.juhaowu.cn/intbaseapi/base/ipFrom",
        address:"https://official.juhaowu.cn",
        // banner 视频
        atoscnMp4:"https://image.juhaowu.cn/cn_video/video/atos-cn.mp4",
        atoscnMp4480: "https://image.juhaowu.cn/cn_video/video/atoshi-480p.MOV",
        atoscnMp4720: "https://image.juhaowu.cn/cn_video/video/atoshi-720p.MOV",
        atoscnMp41080: "https://image.juhaowu.cn/cn_video/video/atoshi-1080p.MOV",
        // 廖总及项目介绍
        ceoAtoscnMp4: "https://image.juhaowu.cn/cn_video/video/CNATOSHI.mp4",
        ceoAtoscnMp4480: "https://image.juhaowu.cn/cn_video/video/CNATOSHI480p.mp4",
        ceoAtoscnMp4720: "https://image.juhaowu.cn/cn_video/video/CNATOSHI720p.mp4",
        ceoAtoscnMp41080: "https://image.juhaowu.cn/cn_video/video/CNATOSHI1080p.mp4",
        // 正式
        downloadUrl:"https://share-plus.juhaowu.net/#/xiazaiye?from=singlemessage",
        // 测试
        // downloadUrl:"http://appone.libangtianbo.net.cn/#/xiazaiye",
        // h5 下载海外版 正式
        seaAtoshiDownloadUrl:"https://www.atoshi.org/globaldownload/#/?language=zh-cn&timestamp=" + new Date().getTime(),
        // h5 下载海外版 测试
        // seaAtoshiDownloadUrl:"http://aboard-h5-test.juhaowu.cn/#/download",
        // 乐唰下载
        leshuaDownload:"https://leshua.info",
        // 游戏下载
        gamesDownload:"https://game-img.atoshi.mobi/official/box_mobile.jpg",
         // 区块链地址
         seaAtoshiChainUrl:"https://scan.atoverse.info",
        // 钱包地址
        walletUrl: "https://wallet.atoshi.org",
        // 原宇宙
        metatUrl: "https://meta.libangbo.cn/",
        // 密码箱
        keyUrl: "https://www.atoshikey.com/#/",
        // 小原子早晚安
        miniDaily: "https://inviteh5.bohongyu.online/download",
        // 原子链AI
        atoshiAI: "https://open.weixin.qq.com/qr/code?username=gh_a64d66abe4b5",
        // uniswap币币兑换链接
        uniswapUrl: "https://app.uniswap.org/swap?use=V2&inputCurrency=USDT&outputCurrency=0x4d0528598f916fd1d8dc80e5f54a8feedcfd4b18&lng=zh-Hans",
        // 乐唰url
        lsUrl: "https://www.atoshi.info/leshua/#/",
        // telgramUrl
        telgramUrl: "https://t.me/atoshiofficial",
        detokUrl:"https://www.atoshi.info/detok/#/",

        // 图片链接
        addressZh:"https://video2.juhaowu.cn/static-web/mobile_img/mobile_zh",
        addressEn:"https://video2.juhaowu.cn/static-web/mobile_img/mobile_en",
        addressCommon:"https://video2.juhaowu.cn/static-web/mobile_img/common/img",
        addressZh1:"https://video2.juhaowu.cn/static-web/pc_zh1",
        addressEn1:"https://video2.juhaowu.cn/static-web/pc_en1",

        addressPublic: "https://video2.juhaowu.cn/static-web/atoshiorg",
    };




// WEBPACK FOOTER //
// ./src/enum.js